import axios from 'axios';
import User from '../services/User';

export default () => {
  const userProvider = new User();

  axios.interceptors.request.use(async (config) => {
    if (!config.public) {
      const token = await userProvider.getUserToken();
      userProvider.setUserToken(token);
      if (!config.headers.common['X-Id-Token']) {
        config.headers.common['X-Id-Token'] = token;
      }
    }
    return config;
  }, err => Promise.reject(err));

  axios.interceptors.response.use(response => Promise.resolve(response), error => Promise.reject(error.response || error));
};



// WEBPACK FOOTER //
// ./app/src/shared/axiosInterceptor.js